import { useLocation, useNavigate } from "react-router-dom";

const useQueryParam = (key: string) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);

  const get = () => params.get(key);

  const set = (newValue: string) => {
    params.set(key, newValue);
    navigate({ search: params.toString() });
  };

  const setMore = (newParams: { [key: string]: string }) => {
    Object.keys(newParams).forEach((paramKey) => {
      params.set(paramKey, newParams[paramKey]);
    });
    navigate({ search: params.toString() });
  };

  const remove = () => {
    params.delete(key);
    navigate({ search: params.toString() });
  };

  return { get, set, setMore, remove };
};

export default useQueryParam;